<template>
  <b-modal v-bind:id="id"
          class="learning-tutorial"
          ref="modal"
          no-close-on-backdrop
          no-close-on-esc
          centered
          hide-header
          hide-footer>
    <slot>
      <div class="carousel-caption-container">
        <button type="button" 
          ref="prevIcon" 
          class="prev-icon"
          :disabled="slide === 0 " 
          @click="prevSlide()">
          <img src="/static/images/ic-right-arrow-copy.svg" />
        </button>
        <button type="button" ref="nextIcon" class="next-icon" @click="nextSlide()">
          <img src="/static/images/ic-right-arrow.svg" />
        </button>
      </div>

      <b-carousel id="carousel"
        ref="carousel"
        navigationNextLabel="NEXT"
        background="#ababab"
        :interval="0"
        img-width="1024"
        img-height="1024"
        v-model="slide">

      <b-carousel-slide img-src="/static/images/bg-sam-info-modal.png">
        <div>
          <div class="learning-tutorial-title">{{ $t('tutorial.step_1.title') }}</div>
          <div class="learning-tutorial-description">
            {{ $t('tutorial.step_1.greeting') }} {{ isParentUser ? $t('common.parent') : `${userName}${$t('common.student')}!` }}<br>
           <span v-html="$t('tutorial.step_1.description')"/>
          </div>
          <img class="learning-tutorial-icon" src="/static/images/img-intro-01.png" alt="icon" />
          <div class="button-container">
            <button type="button" class="next-button" @click="nextSlide()">{{ $t("common.next") }}</button>
          </div>
        </div>
      </b-carousel-slide>

      <b-carousel-slide img-src="/static/images/bg-sam-info-modal.png" v-if="!isParentUser">
        <div class="learning-tutorial-title">{{ $t("tutorial.step_2.title") }}</div>
        <div v-html="$t('tutorial.step_2.description')" class="learning-tutorial-description" />
        <div class="learning-tutorial-setting row">
          <div class="col-6">
            <div class="school-label">{{ $t('common.school_info') }}</div>
            <div class="school-value">{{ userSchool || '-' }}</div>
          </div>
          <div class="col-6">
            <div class="school-label">{{ $t('common.grade_info') }}</div>
            <div class="school-value">{{ userGrade || '-' }}</div>
          </div>
        </div>
        <div class="button-container">
          <button type="button" class="setting-button" @click="openClassting()">{{ $t('tutorial.step_2.update_school') }}</button>
          <button type="button" class="next-button" ref="nextButton" @click="nextSlide()">{{ $t('common.next') }}</button>
        </div>
      </b-carousel-slide>

      <b-carousel-slide img-src="/static/images/bg-sam-info-modal.png">
        <div class="learning-tutorial-title">{{ $t('tutorial.step_3.title') }}</div>
        <div class="learning-tutorial-description" v-html="$t('tutorial.step_3.description')" />
        <img class="learning-tutorial-icon" src="/static/images/img-intro-02.png" alt="icon" />
        <div class="button-container">
          <button type="button" class="next-button" @click="nextSlide()">{{ $t('common.next') }}</button>
        </div>
      </b-carousel-slide>

      <b-carousel-slide img-src="/static/images/bg-sam-info-modal.png">
        <div class="learning-tutorial-title">{{ $t('tutorial.step_4.title') }}</div>
        <div class="learning-tutorial-description" v-html="$t('tutorial.step_4.description')" />
        <img class="learning-tutorial-icon" src="/static/images/img-intro-03.png" alt="icon" />
        <div class="button-container">
          <button type="button" class="next-button" @click="nextSlide()">{{ $t('common.next') }}</button>
        </div>
      </b-carousel-slide>

      <b-carousel-slide img-src="/static/images/bg-sam-info-modal.png">
        <div class="learning-tutorial-title">
          {{ $t('tutorial.step_5.title', { user: isParentUser ? $t('common.child') : $t('common.me') }) }}
        </div>
        <div class="learning-tutorial-description" v-html="$t('tutorial.step_5.description')" />
        <img class="learning-tutorial-icon" src="/static/images/img-intro-04.png" alt="icon" />
        <div class="button-container">
          <button type="button" class="next-button" @click="modalHide()">{{ $t('tutorial.step_5.end_tutorial') }}</button>
        </div>
      </b-carousel-slide>

      </b-carousel>

    </slot>
  </b-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { CLASSTING_URL } from '@/config';
  import labels from '@/mixins/labels';

  export default {
    name: 'cat-tutorial',

    mixins: [
      labels,
    ],

    props: {
      id: String,
    },

    data() {
      return {
        slide: 0,
      };
    },

    computed: {
      ...mapGetters({
        checkedTutorials: 'checkedTutorials',
        currentUser: 'currentUser',
        isParentUser: 'isParentUser',
        isSupportUser: 'isSupportUser',
        gradeMap: 'getGradeMap',
        currentUserRole: 'currentUserRole',
      }),

      userName() {
        return this.currentUser && this.currentUser.name;
      },

      userSchool() {
        return this.currentUser && this.currentUser.school_name;
      },

      userGrade() {
        if (!this.currentUser.grade) {
          return null;
        }

        return this.gradeMap && this.getTranslatedName(this.gradeMap[this.currentUser.grade]);
      },

      isNextButtonDisabled() {
        if (!this.isParentUser && !this.currentUser.grade && !this.userSchool) {
          return true;
        }
        return false;
      },
    },

    methods: {
      ...mapActions([
        'setTutorialAsChecked',
        'fetchUser',
      ]),

      modalHide() {
        this.$refs.modal.hide();
        this.setTutorialAsChecked('learningIntro');
      },

      nextSlide() {
        this.$refs.carousel.next();
      },

      prevSlide() {
        this.$refs.carousel.prev();
      },

      openClassting() {
        const openedClassting = window.open(`${CLASSTING_URL}/settings/personal_info`);
        const delay = setInterval(() => {
          if (openedClassting.closed) {
            clearInterval(delay);
            this.fetchUser();
          }
        }, 1000);

        return true;
      },
    },

    mounted() {
      this.$refs.modal.show();
    },

    watch: {
      slide(number) {
        if (number === (this.$refs.carousel.slides.length - 1)) {
          this.$refs.nextIcon.disabled = true;
        }

        if (number !== (this.$refs.carousel.slides.length - 1)) {
          this.$refs.nextIcon.disabled = false;
        }

        if (number === 1 && this.isNextButtonDisabled) {
          this.$refs.nextIcon.disabled = true;
          this.$refs.nextButton.disabled = true;
          this.$refs.nextButton.style.opacity = 0.4;
        }
      },

      isNextButtonDisabled() {
        if (!this.isNextButtonDisabled) {
          this.$refs.nextIcon.disabled = false;
          this.$refs.nextButton.disabled = false;
          this.$refs.nextButton.style.opacity = 1;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .learning-tutorial {
    .learning-tutorial-title {
      color: #00c896;
      font-size: 24px;
    }

    .learning-tutorial-description {
      color: rgba(0, 0, 0, 0.87);
      font-size: 16px;
      padding-top: 24px;
      height: 84px;

      @media (max-width: 460px) {
        font-size: 14px;
      }
    }

    .learning-tutorial-icon {
      @media (max-width: 460px) {
        width: 180px;
        height: 180px;
      }

      @media (max-width: 360px) {
        width: 120px;
        height: 120px;
      }
    }

    .learning-tutorial-setting {
      color: #000000;
      padding: 12% 0 12% 0;

      .school-label {
        color: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        padding: 8px 0px 8px 0px;
      }

      .school-value {
        font-size: 18px;
        padding: 8px 0px 8px 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 48px;
        word-break: break-all;
      }

      .grade-label {
        color: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        padding: 8px 0px 8px 0px;
      }

      .grade-value {
        font-size: 18px;
      }
    }

    .button-container {
      text-align: center;

      .setting-button {
        border-radius: 4px;
        border: 1px solid #00c896;
        background: none;
        color: #00c896;
        padding: 3% 22%;
        width: 100%;
        cursor: pointer;
        font-size: 18px;
        margin: 14px 0px 14px 0px;

        @media (max-width: 460px) {
          font-size: 14px;
        }
      }

      .next-button {
        border-radius: 4px;
        background-color: #00c896;
        color: #ffffff;
        border: 0;
        padding: 3% 22%;
        width: 100%;
        cursor: pointer;
        font-size: 18px;

        @media (max-width: 460px) {
          font-size: 14px;
        }
      }
    }

    .carousel-caption-container {
      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;

      .next-icon {
        position: fixed;
        top: 48%;
        right: 0;
      }

      .prev-icon {
        position: fixed;
        top: 48%;
        left: 0;
      }

      button {
        border: none;
        background: none;
        cursor: pointer;
        z-index: 2;
        color: #000000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CatTutorial.vue?1efdeb33